import { Box, useMediaQuery, useTheme } from "@mui/material";
import { usePageTitle } from "hooks/usePageTitle";
import { NAVBAR_HEIGHT } from "constants/layout";
import LogsViewerContent from "scenes/logs/LogsViewerContent";

/**
 * Logs page (admin only — route guard lives in App.js).
 *
 * Shows the log viewer DIRECTLY on the page (no overlay): the old Logs
 * Viewer overlay content was extracted to <LogsViewerContent> and renders
 * inline here. Reached from the sidebar "Logs" entry (2026-10-05 — replaced
 * the Bug Reports screen, which was removed client-side).
 *
 * Standard list-screen height convention: fixed calc(100vh − NAVBAR_HEIGHT)
 * with a 100dvh @supports override, so the content area scrolls on its own
 * while the page fills the viewport (mobile + desktop).
 */
const Logs = () => {
  usePageTitle("Logs");

  const theme = useTheme();
  // Single mobile breakpoint used across the app (matches the sibling screens)
  const isMobile = !useMediaQuery("(min-width:600px)");

  return (
    <Box
      p="1rem 1rem 0 1rem"
      bgcolor={theme.palette.background.alt}
      sx={{
        flex: 1,
        position: "relative",
        height: `calc(100vh - ${NAVBAR_HEIGHT + (isMobile ? 0 : 20)}px)`,
        // 100dvh where supported: bottom controls stay clear of iOS Safari's collapsing chrome
        "@supports (height: 100dvh)": {
          height: `calc(100dvh - ${NAVBAR_HEIGHT + (isMobile ? 0 : 20)}px)`,
        },
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Scrollable content area — entries page in via "Load more" */}
      <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        <LogsViewerContent />
      </Box>
    </Box>
  );
};

export default Logs;
